import { handleAjaxError } from "./handleAjaxError";
import { removePinnedMessageCard } from "./pinMessage";

/**
 * Deletes / unpins a pinned message from the Pinned Messages view (.g-chatform-pinned).
 * This removes the pinned snapshot from user's saved pins without deleting the actual chat message from the database.
 * 
 * @param {jQuery} action
 */
export function deletePinnedMessage(action) {
    action.click(function (event) {
        event.preventDefault();

        let submitBtn = $(this);
        let messageId = submitBtn.closest('.g-chatform-message').attr('data-id');

        if (submitBtn.hasClass('is-loading') || submitBtn.hasClass('is-disabled')) {
            return;
        }

        if (!messageId) {
            removePinnedMessageCard(submitBtn);
            return;
        }

        submitBtn.addClass('is-loading');

        jQuery.ajax({
            url: growtype_chat_ajax.url,
            type: 'post',
            data: {
                message_id: messageId,
                action: growtype_chat_ajax.pin_message_action,
                nonce: growtype_chat_ajax.nonce,
            },
            success: function (response) {
                removePinnedMessageCard(submitBtn);
            },
            error: function (response) {
                handleAjaxError(response, submitBtn);
            }
        });
    });
}
